import React from 'react';
import './styles.css';
import Button from '../Button';

const Repeater = ({items, renderItem, onAdd, onDelete, renderHeader, addNewText = 'Add New'}) => {
  return (
    <div className={'repeater'}>
      <div className={'repeater__items'}>
        {items.map((item, index) => (
          <details className={'repeater__item'} key={index} open>
            <summary className={'repeater__item-header'}>
              {!!renderHeader ? (
                renderHeader(item, index)
              ) : (
                <>Item {index + 1}</>
              )}

              <div className={'repeater__item-header--right'}>
                {!!onDelete && item.removable !== false && (
                  <Button
                    type={'button'}
                    size={'s'}
                    variant={'danger-light'}
                    onClick={() => {
                      onDelete(index);
                    }}
                  >
                    Remove
                  </Button>
                )}
                <svg width={16} height={16} aria-hidden="true" focusable="false" className="repeater__item-header-icon" role="img" viewBox="0 0 448 512">
                  <path fill="currentColor"
                        d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
                </svg>
              </div>
            </summary>
            <div className={'repeater__item-body'}>
              {renderItem(item, index)}
            </div>
            {!!onDelete && item.removable !== false && (
              <div className={'repeater__item-footer'}>
                <Button
                  type={'button'}
                  size={'s'}
                  variant={'danger'}
                  onClick={() => {
                    onDelete(index);
                  }}
                >
                  Remove
                </Button>
              </div>
            )}
          </details>
          ))}
      </div>
      {!!onAdd && (
        <div>
          <Button
            type={'button'}
            size={'s'}
            onClick={onAdd}
          >
            {addNewText}
          </Button>
        </div>
      )}
    </div>
  )
};

export default Repeater;
